/**
 * OTL — Collection card color swatch image swap.
 *
 * Clicking a swatch on a product card swaps the card's primary image
 * to that color's variant featured image. The variant image URL is
 * emitted into each swatch as `data-image` by snippets/collection-swatch.liquid.
 */
(function () {
  'use strict';

  function normalizeUrl(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    return u;
  }

  function swapImage(card, imageUrl) {
    if (!card || !imageUrl) return;
    var primary = card.querySelector('[data-primary-media]');
    if (!primary) return;

    var url = normalizeUrl(imageUrl);

    var img = primary.querySelector('img');
    if (img) {
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-widths');
      img.setAttribute('src', url);
      img.setAttribute('data-src', url);
      img.classList.add('lazyloaded');
      img.classList.remove('lazyload');
      img.style.opacity = '1';
    }

    var sources = primary.querySelectorAll('source');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('srcset', url);
    }

    var bgEls = primary.querySelectorAll('[style*="background"]');
    for (var j = 0; j < bgEls.length; j++) {
      bgEls[j].style.backgroundImage = 'url(' + url + ')';
    }
  }

  function setActive(swatchEl) {
    var container = swatchEl.parentElement;
    if (!container) return;
    var siblings = container.querySelectorAll('[data-swatch]');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('is-active');
    }
    swatchEl.classList.add('is-active');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var swatch = e.target.closest('[data-swatch]');
    if (!swatch) return;
    var imageUrl = swatch.getAttribute('data-image');
    if (!imageUrl) return;
    if (/no[-_]image|placeholder/i.test(imageUrl)) return;
    e.preventDefault();
    e.stopPropagation();
    var card = swatch.closest('[data-product-thumbnail]');
    swapImage(card, imageUrl);
    setActive(swatch);
  }, false);
})();
